import { Component, Inject } from '@angular/core';
import { Store, StoresService } from '../../core/stores.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LongRange, LongRangeService } from '../../core/long-range.service';
import { ErrorService } from '../../core/error.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-stores-allowed-steps-dialog',
  templateUrl: './stores-allowed-steps-dialog.component.html',
  styleUrls: ['./stores-allowed-steps-dialog.component.scss'],
})
export class StoresAllowedStepsDialogComponent {
  store?: Store;
  default_long_ranges?: LongRange[];
  is_list_long_ranges_running: boolean = true;

  displayed_columns: string[] = ['amount_range', 'allowed_steps'];

  constructor(
    private dialog_ref: MatDialogRef<StoresAllowedStepsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private long_range_service: LongRangeService,
    private error_service: ErrorService,
    private stores_service: StoresService,
    private utils_service: UtilsService,
  ) {
    this.store = data.store;
  }

  ngOnInit(): void {
    this.readStore(this.store?.store_id as string);
  }

  onRefresh(): void {
    this.readStore(this.store?.store_id as string);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  readStore(store_id: string): void {
    this.is_list_long_ranges_running = true;
    this.stores_service.readStore(store_id).subscribe({
      next: response => {
        this.store = response.data;
        this.listLongRanges();
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_list_long_ranges_running = false;
      },
    });
  }

  listLongRanges(): void {
    this.is_list_long_ranges_running = true;
    this.long_range_service.list().subscribe({
      next: response => {
        this.default_long_ranges = response.data;
        this.is_list_long_ranges_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_list_long_ranges_running = false;
      },
    });
  }

  isChecked(step: number, default_long_range: LongRange): boolean {
    const store_long_range = this.store?.long_ranges?.filter(
      slr => slr.min_amount === default_long_range.min_amount && slr.max_amount === default_long_range.max_amount,
    )[0];

    if (store_long_range) {
      return store_long_range.allowed_steps?.includes(step) || false;
    }

    return false;
  }

  getLongRangeLabel(long_range: LongRange): { min_label: number; max_label: number } {
    return this.utils_service.getLongRangeLabel(long_range);
  }
}
